import { Input, Component, OnInit, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef, ViewRef} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {take, map, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import { TherapiesActionCreatorService } from '@ispm/therapies/services/therapies-action-creator.service';
import { Subject } from 'rxjs/Subject';
import { PerformerLevels } from '@ispm/therapies/constants/performer-levels.enum';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { get } from 'lodash';
import { ConfigurationStoreHandler } from '../../../configuration/services/configuration-store-handler.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { RESOURCE_TYPE_NAME } from "@ispm/therapies/constants/default-clinical-recommendation-sorting-configuration.constant";
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {combineLatest} from "rxjs";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'gen-treatments',
  templateUrl: './treatments.component.html',
  styleUrls: ['./treatments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('TreatmentsSelection')
export class TreatmentsComponent implements OnInit, OnDestroy, IWidgetItem {
  public resourcesMap$: Observable<{ [name in RESOURCE_TYPE_NAME]?: any[]}>;
  public readonly assigneeLevel: PerformerLevels = PerformerLevels.PERFORMER;
  public revisionId: string;
  public workflowId: string;
  @Input()
  public version: number = 2;
  public version$: Observable<number>;
  public performerLevel: number;
  public resolvers = [];
  public resources = { };

  private componentDestroyer$: Subject<void> = new Subject<void>();
  private testId: string;

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    Object.assign(this, widgetConfig.widgetPayload);
  }

  set widgetData(widgetData: any) {

  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private userAC: UserActionCreatorService,
    private therapiesAC: TherapiesActionCreatorService,
    private workflowConfigService: WorkflowConfigService,
    private _changeDetector: ChangeDetectorRef,
    private configurationHandler: ConfigurationStoreHandler,
  ) {
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.revisionId = this.activatedRoute.parent.snapshot.params.revisionId;
    this.workflowId = this.activatedRoute.parent.snapshot.params.testId;
    this.testId = this.activatedRoute.parent.snapshot.params.testId;

    this.therapiesAC.initUserReviewState(this.revisionId, true)
      .then(() => this.initListeners());

    this.setCurrentPractitionerLevel();

    // TODO this method must be removed when we will implement webSockets
    this.removeFlagForProceedTestStage();
  }

  private initListeners() {
    this.version$ = this.configurationHandler.getCurrentConfig().pipe(
      distinctUntilChanged(),
      map(definition => get(definition, 'TreatmentLayout.globals.version', this.version)),
    );

    this.resourcesMap$ = this.therapiesAC.prefetchTestResources();
    this._changeDetector.markForCheck();
  }

  private removeFlagForProceedTestStage() {
    const proceedData = JSON.parse(localStorage.getItem('test-proceed')) || [];

    if (proceedData.includes(this.revisionId)) {
      localStorage.setItem('test-proceed', JSON.stringify(proceedData.filter(item => item !== this.revisionId)));
    }
  }

  setCurrentPractitionerLevel() {
    combineLatest([
      this.workflowConfigService.getActiveWorkflow().pipe(
        filter(workflow => !!workflow),
      ),
      this.userAC.getCurrentUser()
    ]).pipe(
      take(1),
      tap(([currentWorkflow, user]) => {
        for (const reference of currentWorkflow.references) {
          if (reference.type.toLowerCase() === 'practitioner') {
            let value;

            try {
              value = JSON.parse(reference.value);
            } catch (e) {
              continue;
            }

            if (value.practType === 'performer') {
              if (value.practId === user.id) {
                this.performerLevel = PerformerLevels.PERFORMER;
              } else if (value.practId.toLowerCase() === 'none') {
                this.performerLevel = PerformerLevels.POOL;
              } else {
                this.performerLevel = PerformerLevels.UNASSIGNED;
              }

              break;
            }
          }
        }
      })
    )
    .subscribe();
  }

  ngOnDestroy(): void {
    this.componentDestroyer$.next();
    this.componentDestroyer$.complete();
  }
}
